<script>
export default {
    data () {
        return {}
    },
    props: {
        portfolio: {
            type: Object,
            required: true,
        },
    },
    computed: {
        backgroundStyles () {
            const styles = []

            if (this.portfolio.background.color) {
                styles.push(`background-image: url(${this.portfolio.background.color});`)
            }

            return styles.join(' ')
        },

    },
    methods: {
        makeRelativeLink (url) {
            if (url.includes('psgequity.com/')) {
                const urlObj = new URL(url)
                return urlObj.pathname
            }
            return url
        },
    },
}
</script>

<template>
    <article class="partner-card" :style="backgroundStyles">
        <a :href="makeRelativeLink(portfolio.link)" class="bare-link">
            <div class="partner-card__image background-image">
                <img :src="portfolio.background.image" alt="" />
            </div>
            <!-- /.background-image -->
            <div class="partner-card__logo">
                <img :src="portfolio.featuredImage" />
            </div>
            <!-- /.partner-card__logo -->
            <div class="partner-card__info">
                <div class="partner-card__info-wrapper">
                    <h2 class="partner-card__title">
                        {{ portfolio.title }}
                    </h2>
                    <div class="partner-card__description" v-html="portfolio.excerpt"></div>
                </div>
                <!-- /.partner-card__info-wrapper -->
            </div>
            <!-- /.partner-card__info -->
        </a>
    </article>
</template>
